import * as React from "react";
const IconOpenSign = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M57.3 13.9H6.7C4.1 13.9 2 16 2 18.6v26.7C2 47.9 4.1 50 6.7 50h50.6c2.6 0 4.7-2.1 4.7-4.7V18.6c0-2.6-2.1-4.7-4.7-4.7M60 45.4c0 1.5-1.2 2.7-2.7 2.7H6.7c-1.5 0-2.7-1.2-2.7-2.7V18.6c0-1.5 1.2-2.7 2.7-2.7h50.6c1.5 0 2.7 1.2 2.7 2.7z" />
    <path d="M29.3 24.8h-6.7c-.6 0-1 .4-1 1v13c0 .6.4 1 1 1s1-.4 1-1v-6.1h5.7c.6 0 1-.4 1-1v-5.8c0-.6-.4-1.1-1-1.1m-1 5.9h-4.7v-3.8h4.7zM16.4 24.8H9.7c-.6 0-1 .4-1 1v13c0 .6.4 1 1 1h6.7c.6 0 1-.4 1-1v-13c0-.5-.4-1-1-1m-1 13h-4.7v-11h4.7zM54.4 24.8c-.6 0-1 .4-1 1v8.6l-4.7-9c-.2-.4-.7-.6-1.1-.5s-.8.5-.8 1v12.6c0 .6.4 1 1 1s1-.4 1-1v-8.6l4.7 9c.2.3.5.5.9.5h.2c.4-.1.8-.5.8-1V25.8c0-.5-.4-1-1-1M40.8 26.8c.6 0 1-.4 1-1s-.4-1-1-1h-5c-.6 0-1 .4-1 1v12.6c0 .6.4 1 1 1h5c.6 0 1-.4 1-1s-.4-1-1-1h-4v-4.3h1.5c.6 0 1-.4 1-1s-.4-1-1-1h-1.5v-4.3z" />
  </svg>
);
export default IconOpenSign;
